/**
 * Daily downloads the WebRTC call machine from its CDN the first time a call
 * object loads. Vapi creates that object inside start(), so the first click
 * waits on the download.
 *
 * Load one headless call object as soon as the page starts. Destroy it before
 * Vapi start(): Daily allows a single call instance, and the evaluated bundle
 * stays available for the real call.
 */
import Daily from '@daily-co/daily-js';

let call = null;
let ready = null;

export function preloadVapiWebRtc() {
  if (ready || typeof Daily?.createCallObject !== 'function') return ready;
  ready = (async () => {
    const next = Daily.createCallObject({
      audioSource: false,
      videoSource: false,
    });
    call = next;
    await next.load();
  })().catch((error) => {
    console.warn('[VAPI] WebRTC preload failed', error);
    const failed = call;
    call = null;
    ready = null;
    if (failed && typeof failed.destroy === 'function') {
      failed.destroy().catch(() => {});
    }
  });
  return ready;
}

export async function releasePreloadedVapiWebRtc() {
  const pending = ready;
  ready = null;
  if (pending) {
    try {
      await pending;
    } catch (e) {
      // preloadVapiWebRtc already logged the failure
    }
  }
  const current = call;
  call = null;
  if (current && typeof current.destroy === 'function') {
    try {
      await current.destroy();
    } catch (e) {
      // The instance may already be gone.
    }
  }
}
